import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import CancelTasksWorkstation from "../../components/actionButtons/cancelTasksWorkstation";
import TaskActions from "../../components/actionButtons/taskActionButtons";
import Loader from "../../components/Common/Loader";
import TaskFilters from "../../components/Lists/TaskFilters";
import TaskList from "../../components/Lists/TaskList";
import { taskfields, task_status, taskStatusBack } from "../../constants/task_fields";
//Import actions redux
import {
  getSystemStatus,
  getTask,
  getWorkstations,
  getWsPositions,
  queryTaskStatusStart,
  resendTask,
  pauseQueueTask,
  resumeQueueTask,
} from "../../store/actions";
import "./datatables.scss";

class TasksWorkStations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      workstations_tasks: null,
      nextid: 0,
      creationDisabled: false,
      showAlert: false,
      totalPages: 1,
      showAlertResend: false,
      showAlertQueryStat: false,
      // P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad).
      filters: { status: '', rack: '', workstation: '', position: '', priorityMin: '', priorityMax: '' },
    };
  }

  componentDidMount() {
    this.props.getTask(this.state.user, 100, 1);
    this.props.getWorkstations(this.state.user);
    this.props.getWsPositions(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingGetTask === false && prevProps.loadingGetTask === true) {
      let tasks = this.props.tasks.elements;
      this.setState({ totalPages: this.props.tasks.totalPages });
      if (tasks) {
        this.prepareData(tasks);
      }
    }
    if (this.props.loadingGetWs === false && prevProps.loadingGetWs === true) {
      console.log("ws fetched");
      let ws = this.props.ws;
      if (ws) {
        if (ws.length === 0) {
          console.log("no ws CREATED");
          this.setState({ creationDisabled: true });
        }
      }
    }
    if (prevProps.messageQueryStatusTask === null && this.props.messageQueryStatusTask === true) {
      this.refetchTasks();
    }
    if (prevProps.messageResend === null && this.props.messageResend === true) {
      this.refetchTasks();
    }

    // P01021-147 (reporte cliente): estas 4 acciones hacían history.go() (recarga completa del
    // navegador) tras completarse, perdiendo el filtro aplicado (estado de TaskFilters, en
    // memoria). Ahora solo refrescan el listado, conservando this.state.filters.
    if (this.props.loadingReturnTask === false && prevProps.loadingReturnTask === true) {
      this.refetchTasks();
    }

    if (this.props.pendingToreturnTaskLoading === false && prevProps.pendingToreturnTaskLoading === true) {
      this.refetchTasks();
    }

    if (this.props.loadingPauseQueueTask === false && prevProps.loadingPauseQueueTask === true) {
      this.refetchTasks();
      // P01021-147bis: el botón "Pausar/Reanudar tareas" lee this.props.taskStatus, que solo se
      // pedía una vez al montar el layout (Header.js) — con history.go() una recarga completa lo
      // refrescaba de rebote; sin ella, hay que volver a pedirlo explícitamente aquí.
      this.props.getSystemStatus(this.state.user);
    }

    if (this.props.loadingResumeQueueTask === false && prevProps.loadingResumeQueueTask === true) {
      this.refetchTasks();
      this.props.getSystemStatus(this.state.user);
    }
  }

  // P01021-147: refresca solo el listado de tareas, conservando el filtro activo. No limpia
  // this.state.workstations_tasks antes de pedir los datos (se reconstruye en componentDidUpdate
  // cuando llega la respuesta) para no colapsar la tabla en cada refresco.
  refetchTasks() {
    const { status, rack, workstation, position, priorityMin, priorityMax } = this.state.filters;
    this.props.getTask(this.state.user, 100, 1, status, rack, workstation, position, priorityMin, priorityMax);
  }

  prepareData(tasks) {
    let columns = taskfields;
    let workstations_tasks = [];
    let workStationsIndex = {};
    let big = 0;
    tasks.forEach((task) => {
      if (task.taskCode[0] !== "R") {
        if (task.taskCode > big) big = parseInt(task.taskCode);
      }
      task["sgtWS"] = task.sgtTaskStatus >= taskStatusBack.COLA ? "" : task["sgtWS"];
      task["status"] = task_status[task["sgtTaskStatus"]];
      // P01021-145: priority es VARCHAR en BD; sin convertir a número, MDBDataTable
      // lo ordena como texto ("49" antes que "5") al pulsar la cabecera "Prioridad".
      task["priority"] = parseInt(task["priority"], 10);
      task["actions"] = <TaskActions task={task} page_origin="/tasksWorkStations"></TaskActions>;
      console.log(workStationsIndex[task.sgpWS]);
      if (workStationsIndex[task.sgpWS] || workStationsIndex[task.sgpWS] === 0) {
        workstations_tasks[workStationsIndex[task.sgpWS]].rows.push(task);
      } else {
        workStationsIndex[task.sgpWS] = workstations_tasks.length;
        console.log(workstations_tasks.length);
        workstations_tasks.push({ columns: columns, rows: [task] });
      }
    });
    // let data = { columns, rows };
    console.log(workstations_tasks);

    this.setState({ workstations_tasks: workstations_tasks, nextid: big });
  }

  refresh(event) {
    event.preventDefault();
    this.refetchTasks();
  }

  // P01021-145: filtro por servidor (estado, rack, estación, posición, rango de prioridad).
  handleFilterChange(filters) {
    this.setState({ filters }, () => this.refetchTasks());
  }

  newTask(event) {
    event.preventDefault();
    if (this.state.creationDisabled) {
      this.displayAlert();
    } else {
      this.props.history.push({
        pathname: "newtasks",
        query: {
          next_id: this.state.nextid,
          page_origin: "/tasksWorkstations",
        },
      });
    }
  }

  resendTasks() {
    this.setState({ showAlertResend: false });
    this.props.resendTask(this.state.user.token);
  }

  queryTaskStatus() {
    this.setState({ showAlertQueryStat: false });
    this.props.queryTaskStatusStart(this.state.user.token);
  }

  displayAlert() {
    this.setState({ showAlert: true });
  }

  hideAlert() {
    this.setState({ showAlert: false });
  }

  displayAlertResend() {
    this.setState({ showAlertResend: true });
  }

  hideAlertResend() {
    this.setState({ showAlertResend: false });
  }

  displayAlertQueryStat() {
    this.setState({ showAlertQueryStat: true });
  }

  hideAlertQueryStat() {
    this.setState({ showAlertQueryStat: false });
  }

  render() {
    if (!this.state.workstations_tasks || this.props.loadingCancelTask) {
      return (
        <React.Fragment>
          <Loader></Loader>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            {this.state.workstations_tasks.length === 0 ? (
              <Row>
                <Col className="col-12">
                  <Button
                    onClick={(event) => this.refresh(event)}
                    color="primary"
                    className="btn btn-primary buttonStatus usersButtons"
                  >
                    {" "}
                    <i size="lg" className="mdi  mdi-refresh"></i>
                  </Button>
                  {this.state.user.role_id < 3 && (
                    <Button
                      className="btn btn-primary waves-effect waves-light  usersButtons"
                      onClick={(event) => this.newTask(event)}
                    >
                      {this.props.t("Crear nueva tarea")}
                    </Button>
                  )}
                  <Button
                    className="btn btn-primary waves-effect waves-light  usersButtons"
                    onClick={(event) => this.displayAlertResend(event)}
                  >
                    {this.props.t("Reenviar tareas")}
                  </Button>
                  <TaskFilters
                    ws={this.props.ws}
                    ws_positions={this.props.ws_positions}
                    onFilterChange={(filters) => this.handleFilterChange(filters)}
                  />
                  <Card>
                    <CardHeader>
                      <CardTitle> {this.props.t("No hay tareas en el sistema")}</CardTitle>
                    </CardHeader>
                  </Card>
                </Col>
              </Row>
            ) : (
              this.state.workstations_tasks.map((taskList, index) => {
                return (
                  <Row key={index}>
                    <Col className="col-12">
                      {index === 0 && (
                        <>
                          <Button
                            onClick={(event) => this.refresh(event)}
                            color="primary"
                            className="btn btn-primary buttonStatus usersButtons"
                          >
                            {" "}
                            <i size="lg" className="mdi  mdi-refresh"></i>
                          </Button>
                          {this.state.user.role_id < 3 && (
                            <Button
                              className="btn btn-primary waves-effect waves-light  usersButtons"
                              onClick={(event) => this.newTask(event)}
                            >
                              {this.props.t("Crear nueva tarea")}
                            </Button>
                          )}
                          <Button
                            className="btn btn-primary waves-effect waves-light  usersButtons"
                            onClick={(event) => this.displayAlertResend(event)}
                          >
                            {this.props.t("Reenviar tareas")}
                          </Button>
                          <Button
                            className="btn btn-primary waves-effect waves-light  usersButtons"
                            onClick={(event) => this.displayAlertQueryStat(event)}
                          >
                            {this.props.t("Sincronizar tareas")}
                          </Button>
                          {this.props.taskStatus ? (
                            <Button
                              className="btn btn-success waves-effect waves-light  usersButtons"
                              onClick={(event) =>
                                this.props.resumeQueueTask(null, this.state.user.token, this.props.history)
                              }
                            >
                              {this.props.t("Reanudar tareas")}
                            </Button>
                          ) : (
                            <Button
                              className="btn btn-primary waves-effect waves-light  usersButtons"
                              onClick={(event) =>
                                this.props.pauseQueueTask(null, this.state.user.token, this.props.history)
                              }
                            >
                              {this.props.t("Pausar tareas")}
                            </Button>
                          )}
                          <TaskFilters
                            ws={this.props.ws}
                            ws_positions={this.props.ws_positions}
                            onFilterChange={(filters) => this.handleFilterChange(filters)}
                          />
                        </>
                      )}
                      <Card>
                        <CardHeader>
                          <CardTitle>
                            {" "}
                            {this.props.t("Estacion de trabajo")} {" " + taskList.rows[0].sgpWS}{" "}
                            <CancelTasksWorkstation ws={taskList.rows[0].sgpWS}></CancelTasksWorkstation>
                          </CardTitle>
                        </CardHeader>
                        <CardBody>
                          <TaskList
                            taskslist={taskList}
                            totalPages={this.state.totalPages}
                            getTask={this.props.getTask}
                            extraArgs={[
                              this.state.filters.status,
                              this.state.filters.rack,
                              this.state.filters.workstation,
                              this.state.filters.position,
                              this.state.filters.priorityMin,
                              this.state.filters.priorityMax,
                            ]}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                );
              })
            )}
          </div>
        </div>
        {this.state.showAlert && (
          <SweetAlert
            title={this.props.t("Para la creación de tareas debe haber el menos una estación de trabajo disponible")}
            warning
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText={this.props.t("ok")}
            onConfirm={() => this.hideAlert()}
          ></SweetAlert>
        )}
        {this.state.alert}
        {this.state.showAlertResend && (
          <SweetAlert
            title={this.props.t("ATENCIÓN") + ":" + this.props.t("¿Está seguro que desea reenviar las tareas?")}
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            cancelBtnText={this.props.t("cancel")}
            confirmBtnText={this.props.t("ok")}
            onConfirm={() => this.resendTasks()}
            onCancel={() => this.hideAlertResend()}
          >
            {this.props.t("¿Continuar con el reenvío?")}
          </SweetAlert>
        )}
        {this.state.alert}
        {this.state.showAlertQueryStat && (
          <SweetAlert
            title={this.props.t("ATENCIÓN") + ":" + this.props.t("¿Está seguro que desea sincronizar las tareas?")}
            warning
            showCancel
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            cancelBtnText={this.props.t("cancel")}
            confirmBtnText={this.props.t("ok")}
            onConfirm={() => this.queryTaskStatus()}
            onCancel={() => this.hideAlertQueryStat()}
          >
            {this.props.t("¿Continuar con la sincronización?")}
          </SweetAlert>
        )}
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetTask, loadingGetTask, tasks, successTask } = state.GetTasks;
  const { loadingCancelTask } = state.GetTasks;
  const { loadingReturnTask } = state.ReturnTask;
  const { messageQueryStatusTask } = state.queryTaskStatusStart;
  const { messageResend } = state.resendTask;
  const { taskStatus } = state.GetSystemStatus;
  const { errorGetWs, loadingGetWs, ws, successWs } = state.GetWS;
  const { ws_positions } = state.getWsPositions || {};
  // P01021-147: para refrescar el listado (conservando el filtro) cuando cualquiera de estas
  // acciones termina, en vez del history.go() (recarga completa) que hacían antes sus sagas.
  const { pendingToreturnTaskLoading } = state.pendingToReturnTask || {};
  const { loadingUpdateTask: loadingPauseQueueTask } = state.pauseQueueTask || {};
  const { loadingUpdateTask: loadingResumeQueueTask } = state.resumeQueueTask || {};

  return {
    errorGetTask,
    loadingGetTask,
    tasks,
    successTask,
    loadingCancelTask,
    loadingReturnTask,
    errorGetWs,
    loadingGetWs,
    ws,
    successWs,
    messageQueryStatusTask,
    messageResend,
    taskStatus,
    ws_positions,
    pendingToreturnTaskLoading,
    loadingPauseQueueTask,
    loadingResumeQueueTask,
  };
};

export default withRouter(
  connect(mapStateProps, {
    getSystemStatus,
    getTask,
    getWorkstations,
    getWsPositions,
    resendTask,
    queryTaskStatusStart,
    pauseQueueTask,
    resumeQueueTask,
  })(withNamespaces()(TasksWorkStations))
);
